export default __webpack_public_path__ + "static/media/shades.44129d38.svg";